export default __webpack_public_path__ + "static/media/game2.e7354322.svg";